import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ReactInicis from "components/Common/Inicis/ReactInicis";
import { PayPalButton } from "react-paypal-button-v2";
import { useFormContext } from "react-hook-form";
import {
  createServiceInicisBill,
  sendPaypalSuccessMail,
} from "src/service/pay";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { notifyError } from "src/components/Common/Toast";
import { useRouter } from "src/hooks/useRouter";
import { useTranslation } from "react-i18next";

interface CardPaymentProps {
  payCompany: "INICIS" | "PAYPAL" | string;
  inicisData: any;
  currency: string;
  setGoodName: () => string;
  paypalSubscription: any;
}

const CardPayment: React.FC<CardPaymentProps> = ({
  payCompany,
  inicisData,
  currency,
  setGoodName,
  paypalSubscription,
}) => {
  const {
    watch,
    formState: { isValid },
  } = useFormContext();
  const payTerm = watch("payTerm");
  const confirmPolicy = watch("confirmPolicy");
  const licenseCount = watch("licenseCount");
  const priceUid = watch("priceUid");
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({}); // 가입된 서비스 여부
  const route = useRouter();
  const [serviceNo, setServiceNo] = useState<number>(0);
  const { t } = useTranslation();
  const payApply = async ({
    orderID,
    subscriptionID,
  }: {
    orderID: string;
    subscriptionID: string;
  }) => {
    // console.log("isCheckPay", isCheckPay);
    if (isValid) {
      try {
        // if (isRenew) {
        //   setServiceBillUid(serviceBillUid);
        // }

        // if (serviceList !== undefined && serviceList.length > 0) {
        //   setServiceBillUid(serviceList[serviceNo].serviceBillUid);
        // }

        const result = await createServiceInicisBill({
          serviceBillUid: serviceList
            ? serviceList[serviceNo]?.serviceBillUid
            : "",
          userCode: userInfo.userCode,
          billType: "PAY",
          billCode: priceUid, // price의 uid값 전달
          licenseCount,
          orderID,
          subscriptionID,
          payTerm,
          // startTime,
          oldSubscriptionID: "", // 확인 필요
          currency,
          payCompany: subscriptionID === "Inicis" ? "INICIS" : "PAYPAL",
          // referralId,
          // nxacAppUids: selectAppList,
        });
        if (result) {
          if (serviceList === undefined || serviceList.length === 0) {
            // setNavStep(3);
            // setShowSiteNewModal(true);
            // setIsShowPay(false);
            // setIsInit(false);
            // setType("pay");
            // setServiceBillUid(result.serviceBillUid);
          } else {
            route.goConsole();
          }
          if (payCompany === "PAYPAL") {
            route.goConsole();
          }
        } else {
          // 에러
        }
      } catch (error: any) {
        if (error?.errorCode && error?.errorMessage) {
          notifyError(error.errorMessage);
        }
      }
      // this.commonStore.setLoading(false)
    }
  };
  const handlePaypalApprove = (
    data: { orderID: string; subscriptionID: string },
    actions: any
  ) => {
    return actions.subscription.get().then((details: any) => {
      console.log("paypal 결제 성공", details);
      payApply({
        orderID: data.orderID,
        subscriptionID: data.subscriptionID,
      });
      sendPaypalSuccessMail({
        subscriptionId: data.subscriptionID,
      });
    });
  };

  if (payCompany === "INICIS") {
    return (
      <ReactInicis
        payData={inicisData}
        currency={currency}
        goodName={setGoodName()}
      >
        <Button
          variant="success"
          // className="w-100 mt-3 d-flex justify-content-center align-items-center"
          className="btn btn-green btn-40 width w-100p mg mt-20 pd py-10"
          // 서명 데이터(inicisData)가 현재 폼 값 기준으로 갱신되기 전에는 결제 불가
          disabled={!confirmPolicy || !inicisData}
        >
          <img
            src="/resources/images/card.png"
            alt="card"
            width={16}
            height={12}
            className="me-2"
          />
          {t("common.card")}
        </Button>
      </ReactInicis>
    );
  }

  if (payCompany === "PAYPAL") {
    return (
      // <div className={isValid ? "" : "none-click"}>
      <div>
        <PayPalButton
          options={{ vault: true }}
          createSubscription={paypalSubscription}
          onApprove={handlePaypalApprove}
          currency={"USD"}
        />
      </div>
    );
  }

  return null;
};

export default CardPayment;
